module.exports = __webpack_public_path__ + "img/55.1e652e0f.3c8c6b4c.svg";